import { render } from "./LossChart.vue?vue&type=template&id=63404819&scoped=true"
import script from "./LossChart.vue?vue&type=script&lang=js"
export * from "./LossChart.vue?vue&type=script&lang=js"

import "./LossChart.vue?vue&type=style&index=0&id=63404819&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63404819"]])

export default __exports__